import EventFileModal from './EventFileModal';
import './EventFileModal.scss';

export default EventFileModal;
